/** Bump when replacing homepage files at the same path.
 *  6: form-factor posters moved to /web_v2/home-v4/form-factors/.
 *  7: US homepage ring-pro-us set published. SpeedSize had cached the misses.
 *  8: US homepage Figma pass — fit, pay, talk, and heart-rate icon replacements.
 *  9: Refetch the uploaded fit, pay, and talk replacements.
 *  10: Refetch the updated kit-size.png replacement for the US homepage fit section.
 *  11: Emerald film poster — introducing-emerald.jpg (frame @ 2s).
 *  12: CDN sync for extracted Emerald introducing-emerald posters. */
const HOME_ASSET_VERSION = '12';

export function homeAssetSrc(src: string): string {
  const join = src.includes('?') ? '&' : '?';
  return `${src}${join}v=${HOME_ASSET_VERSION}`;
}
